module.exports = __webpack_public_path__ + "img/P150T_weapon_9.0a4dcabc.png";